import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Multiselect from 'vue-multiselect';
import axios from 'axios';
import showAlert from '../alert/alertHandler';
import showConfirmation from '../confirmation/confirmationHandler';

import moment from 'moment';
import badgeStylesRoute from '../resources/badgeStylesRoute.json';

import routeAssignmentEscl from '../locales/es-CL/routeAssignment.json';
import routeAssignmentEsmx from '../locales/es-MX/routeAssignment.json';
import routeAssignmentEsco from '../locales/es-CO/routeAssignment.json';
import routeAssignmentEnus from '../locales/en-US/routeAssignment.json';

const linkDataFormModal = 'link-data-form-modal';

export default {
  name: 'RouteAssignment',
  components: {
    Multiselect,
    VueCtkDateTimePicker,
  },
  i18n: {
    messages: {
      'es-CL': {
        routeAssignment: routeAssignmentEscl,
      },
      'es-MX': {
        routeAssignment: routeAssignmentEsmx,
      },
      'es-CO': {
        routeAssignment: routeAssignmentEsco,
      },
      'en-US': {
        routeAssignment: routeAssignmentEnus,
      },
    },
  },
  data() {
    return {
      vehicleDriverAssigned: false,
      driverVehicleAssigned: false,
      isFilterShown: false,
      isFilterShownModal: false,
      isFilterClicked: false,
      isFilterClickedModal: false,
      isFilterApplied: false,
      isFilterAppliedModal: false,
      isTripDetailBusy: false,
      isTripValid: false,
      dataAccess: null,
      loadSelected: null,
      shortCutPath: null,
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      currentPageRoutes: 1,
      perPageRoutes: 10,
      selectedVehicles: [],
      checkedVehicle: null,
      checkedCargo: null,
      checkedGpsControl: null,
      currentPageVehicles: 1,
      perPageVehicles: 10,
      currentPageTrip: 1,
      perPageTrip: 10,
      pageOptions: [10, 15, 20, 50, 100],
      selectedRoute: null,
      routesAssignment: [],
      checkedRoutesAssignment: [],
      vehicles: [],
      cargos: [],
      gpsControl: [],
      isSendMassiveReady: true,
      isBusy: false,
      isDataLinkBusy: false,
      isVehicleBusy: false,
      isAssignationBussy: false,
      vehiclesAssignments: null,
      filters: {
        clientList: [],
        from: null,
        to: null,
        plateList: [],
        routeAssignmentList: [],
        routeDriverList: [],
        extraData: null,
      },
      options: {
        driverList: [],
        plateList: [],
        nameList: [],
        idList: [],
        extraData: [],
      },
      modalLinkFilters: {
        clientList: [],
        groupList: [],
        typeList: [],
        vehicleList: [],
      },
      clientSelected: null,
      routeAssignmentSelected: null,
      plateSelected: null,
      routeClientSelected: null,
      routeGroupSelected: null,
      routeTypeSelected: null,
      routeDriverSelected: null,
      routeDriverRadioSelected: null,
      idRoute: null,
      name: null,
      badges: badgeStylesRoute,
      rawRoutes: [],
      rawVehiclesAssignment: [],
      rawVehicles: [],
      selectedAll: false,
      keywordPlate: '',
      keywordPlateTable: '',
      extraData: null,
      statusOption: [],
      statusSelected: '',
      routesFilteredData: [],
      keywordOper: '',
      tripsAssignation: [],
      selectedAllTrip: false,
      checkedTrips: [],
      dynamicOptions: [],
      keywordVehicle: '',
      keywordOperator: '',
      tripsVisual: [],
      isCargoAvaiable: false,
      isGpsControlAvailable: false,
      loadSection: [
        { charge: 10, percetage: '10%' },
        { charge: 20, percetage: '20%' },
        { charge: 30, percetage: '30%' },
        { charge: 40, percetage: '40%' },
        { charge: 50, percetage: '50%' },
        { charge: 60, percetage: '60%' },
        { charge: 70, percetage: '70%' },
        { charge: 80, percetage: '80%' },
        { charge: 90, percetage: '90%' },
        { charge: 100, percetage: '100%' },
      ],
      indexAssigned: -1,
      indexOngoing: -1,
      unAssignedNotLoading: true,
      onGoingIsBussy: true,
    };
  },
  async created() {
    await this.prepareData();
  },
  methods: {
    /**
     * Metodo que deriva a otra vista dado ciertos parametros.
     * Prioridad al cambiar de vista: Preparar filtrado instantaneo por id de ruta.
     * @param {Integer} routeId, es la id de la ruta seleccionada.
     * @param {String} path, es el nombre de la vista a la que se desea ir.
     * @returns A la nueva vista.
     */
    async goToAnotherPage(routeId, path) {
      this.isButtonClicked = true;
      await this.$store.commit('saveShortCutPathOrigin', 'Route fulfillment');
      await this.$store.commit('saveIdRouteFlash', routeId);
      return this.$router.push({ name: path });
    },

    /**
     * Metodo especialmente hecho para el multiselect del modal de asignar rutas a un trip, el cual permite imprimir label
     * personalizados para cada elemento del objeto colocado en options del multiselect.
     * @param {String} name  corresponde al atributo name, que representa el nombre de la ruta que se encuentra en routesAssignment.
     * @param {String} idRoute corresponde al atributo idRoute, que representa el id de la ruta que se encuentra en routesAssignment.
     * @returns El nuevo label a presentar en cada opcion del multiselect que se encuentra en el modal de asignar rutas a un trip.
     */
    labelNameIdRoute({ name, idRoute }) {
      return `${name} — ID ${idRoute}`;
    },

    onChangeVehicleRadio() {
      if (this.checkedVehicle) {
        const idVehicle = this.checkedVehicle.id;
        console.log('vehicle selected', idVehicle);
        let checked = false;
        //this.routeDriverSelected = null;
        this.vehicleDriverAssigned = false;
        this.vehiclesAssignments.forEach((vehicleAssined) => {
          vehicleAssined.idVehicle.forEach((vehicle) => {
            if (!checked && idVehicle === vehicle) {
              this.vehicleDriverAssigned = true;
              this.routeDriverSelected = this.filters.routeDriverList.find(
                (driver) => driver.id === vehicleAssined.idDriver,
              );
              checked = true;
            }
          });
        });
        console.log('estados', this.vehicleDriverAssigned);
      }
    },
    onChangeDriverRadio() {
      if (this.routeDriverSelected) {
        const idDriver = this.routeDriverSelected.id;
        console.log('driver selected', idDriver);
        let checked = false;
        //this.checkedVehicle = null;
        this.driverVehicleAssigned = false;
        this.vehiclesAssignments.forEach((driver) => {
          if (!checked && driver.idDriver === idDriver) {
            this.driverVehicleAssigned = true;
            this.checkedVehicle = this.vehicles.find((vehicle) => vehicle.id === driver.idVehicle[0]);
            checked = true;
          }
        });
        console.log('estados', this.routeDriverSelected);
      }
    },
    checkUnAssignUnique(route) {
      return this.tripsVisual.length === 0 && route.assignations && route.assignations.length === 1 ? true : false;
    },
    checkAssignation(route) {
      if (route.assignations.length === 1) {
        let driverData = route.assignations[0].driver
          ? this.filters.routeDriverList.find((driver) => driver.id === route.assignations[0].driver.id)
          : null;
        if (driverData === undefined) {
          driverData = null;
        }
        let vehicleData = route.assignations[0].vehicle
          ? this.vehicles.find((vehicle) => vehicle.id === route.assignations[0].vehicle.id)
          : null;
        if (vehicleData === undefined) {
          vehicleData = null;
        }
        let cargoData = route.assignations[0].cargo
          ? this.cargos.find((vehicle) => vehicle.id === route.assignations[0].cargo.id)
          : null;
        if (cargoData === undefined) {
          cargoData = null;
        }
        let gpsControl = route.assignations[0].gpsControl
          ? this.gpsControl.find((vehicle) => vehicle.id === route.assignations[0].gpsControl.id)
          : null;
        if (gpsControl === undefined) {
          gpsControl = null;
        }
        route.driverDescRow = driverData !== null ? driverData.driverName : '-';
        route.vehicleDescRow = vehicleData !== null ? vehicleData.plate : '-';
        route.cargoDescRow = cargoData !== null ? cargoData.plate : '-';
        route.cargoDescRow = gpsControl !== null ? gpsControl.plate : '-';
      }
      return route.assignations.length > 1;
    },
    viewTrips(route) {
      console.log('de aca saco los trips', route);
      this.tripsVisual = route.trips;
      this.processTripsAssignation(this.tripsVisual);
      this.showModal('link-data-trip-detail-form-modal');
    },
    populateAssignationRoute(assignations, route) {
      let segmentsAssignment = [];
      const tripsForAssignation = this.getAllTripsForAssignation(route); //Esta variable se usa para saber si hay trips no asignados y asi mostrarlos en el expand de asignacion
      //Recorre cada asignacion de la ruta y
      assignations.forEach((element) => {
        let tripsAsigned = [];
        //Captura el dato completo del trip de ruta(Especificamente el address) para utilizarlo como trip asignado
        if (element.state !== 'NOTASSIGNED' && element.trips !== null && element.trips !== undefined) {
          element.trips.forEach((tripAssigned) => {
            route.trips.forEach((trip) => {
              if (tripAssigned.id === trip.id) {
                return tripsAsigned.push(trip);
              }
            });
          });
        }
        let driverData = element.driver
          ? this.filters.routeDriverList.find((driver) => driver.id === element.driver.id)
          : null;
        if (driverData === undefined) {
          driverData = null;
        }

        let vehicleData = element.vehicle ? this.vehicles.find((vehicle) => vehicle.id === element.vehicle.id) : null;
        if (vehicleData === undefined) {
          vehicleData = null;
        }

        let cargoData = element.cargo ? this.vehicles.find((vehicle) => vehicle.id === element.cargo.id) : null;
        if (cargoData === undefined) {
          cargoData = null;
        }

        const startDateTemp = new Date(element.startDate);
        const startSeconds = startDateTemp.getTime();
        const startDate = new Date(startSeconds);

        const endDateTemp = new Date(element.endDate);
        const endSeconds = endDateTemp.getTime();
        const endDate = new Date(endSeconds);

        if (element.state !== 'NOTASSIGNED') {
          segmentsAssignment.push({
            id: element.id,
            vehicle: {
              id: vehicleData !== null ? vehicleData.id : null,
              plate: vehicleData !== null ? vehicleData.plate : '-',
            },
            cargo: {
              id: cargoData !== null ? cargoData.id : null,
              plate: cargoData !== null ? cargoData.plate : '-',
            },
            driver: {
              id: driverData !== null ? driverData.id : null,
              driverName: driverData !== null ? driverData.driverName : '-',
            },
            startTime: Date.parse(element.startDate),
            endTime: Date.parse(element.endDate),
            dateStart: moment(startDate).format('DD/MM/YY hh:mm:ss'),
            dateEnd: moment(endDate).format('DD/MM/YY hh:mm:ss'),
            trips: tripsAsigned,
            status: element.status,
          });
        }
      });
      if (tripsForAssignation.length > 0) {
        const startDateTemp = new Date(route.startDate);
        const startSeconds = startDateTemp.getTime();
        const startDate = new Date(startSeconds);

        const endDateTemp = new Date(route.endDate);
        const endSeconds = endDateTemp.getTime();
        const endDate = new Date(endSeconds);
        segmentsAssignment.push({
          vehicle: {
            plate: this.$t('routeAssignment.table.notState'),
          },
          cargo: {
            plate: '-',
          },
          driver: {
            driverName: this.$t('routeAssignment.table.notState'),
          },
          startTime: Date.parse(route.startDate),
          endTime: Date.parse(route.endDate),
          dateStart: moment(startDate).format('DD/MM/YY'),
          dateEnd: moment(endDate).format('DD/MM/YY'),
          trips: tripsForAssignation,
        });
      }
      return segmentsAssignment;
    },
    resetDataTrips() {
      this.checkedTrips = [];
      this.selectedAll = false;
    },
    async assignDataTripsToRoute() {
      this.isTripDetailBusy = true;
      this.isDataLinkBusy = true;
      const url = `${this.$store.getters.urlAPI}/route/${this.selectedRoute.idRoute}/assignation`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const body = {
        idDriver: this.routeDriverSelected.id,
        idTrips: this.checkedTrips,
        idVehicle: this.checkedVehicle.id,
        idCargo: this.checkedCargo !== null ? this.checkedCargo.id : null,
        idGpsControl: this.checkedGpsControl !== null ? this.checkedGpsControl.id : null,
        totalLoad: this.loadSelected !== null ? this.loadSelected.charge : null,
        idOperator: this.$store.getters.loggedUser['idUser'],
      };

      console.log('body ....', body);
      console.log('url ...', url);
      console.log('config ...', config);
      try {
        await axios.patch(url, body, config);
        if (this.callback) {
          this.callback(this.selectedVehicles);
        }
        showAlert(
          this.$t('routeAssignment.alertMessages.success.title'),
          this.$t('routeAssignment.alertMessages.success.message'),
        );
        await this.handlePageChange();
        console.log('porqe cambio', this.selectedRoute.name, this.selectedRoute.idRoute);
        const updatedRoute = this.routesAssignment.find((route) => route.idRoute === this.selectedRoute.idRoute);
        console.log('porqe cambio', updatedRoute);
        this.changeTripInfo(updatedRoute);
      } catch (e) {
        this.isTripDetailBusy = false;
        if (e.response.data.message === 'notAvailable') {
          const message = this.prepareLinkErrorMessage(e);
          showAlert('Error', message);
        } else {
          showAlert('Error', e.response.data);
          console.log(e);
        }
      }
      this.isDataLinkBusy = false;
    },
    sendTrips() {
      if (this.checkedTrips.length === 0) {
        this.isTripValid = false;
        showAlert('error', 'Al menos tiene que seleccionar 1 viaje');
        return;
      }
      console.log('Conductor', this.filters.routeDriverList);
      if (this.validateOrderTrips()) {
        this.isTripValid = true;
      } else {
        this.isTripValid = false;
        showAlert('error', 'Los viajes deben ser consecutivos');
      }
    },
    validateOrderTrips() {
      //Obtengo los trips a partir del listado de ids checkeados
      const trips = this.tripsAssignation.filter((trip) => this.checkedTrips.includes(trip.id));
      //Ordeno estos trips segun fecha de inicio
      trips.sort((tripA, tripB) => new Date(tripA.startDate).getTime() - new Date(tripB.startDate).getTime());
      //Del listado trips hago un mapeo de ids para usarlos como checkedTrips
      this.checkedTrips = trips.map((t) => t.id);

      //Este for indica si es que los viajes seleccionados son consecutivos o no
      for (let i = 1; i < trips.length; i++) {
        if (
          this.getDateStartTripValidation(this.checkedTrips[i]) !==
          this.getDateEndTripValidation(this.checkedTrips[i - 1])
        ) {
          return false;
        }
      }
      return true;
    },
    getDateEndTripValidation(id) {
      for (let trip of this.tripsAssignation) {
        if (id === trip.id) {
          return trip.endDate;
        }
      }
    },
    getDateStartTripValidation(id) {
      for (let trip of this.tripsAssignation) {
        if (id === trip.id) {
          return trip.startDate;
        }
      }
    },
    processTripsAssignation(trips) {
      for (let trip of trips) {
        const startDateTemp = new Date(trip.startDate);
        const startSeconds = startDateTemp.getTime();
        const startDate = new Date(startSeconds);

        const endDateTemp = new Date(trip.endDate);
        const endSeconds = endDateTemp.getTime();
        const endDate = new Date(endSeconds);

        const origin = this.transformNameAddress(trip.origin, '-');
        const destination = this.transformNameAddress(trip.destination, '-');
        trip.originDesc = origin;
        trip.destinationDesc = destination;

        trip.dateStartTrip = moment(startDate).format('DD/MM/YY HH:mm:ss');
        trip.dateEndTrip = moment(endDate).format('DD/MM/YY HH:mm:ss');
      }
      this.orderTrips(trips);
    },
    /**
     * metodo que transforma el nombre de spot si es que es temporal
     * @param {Json} address
     * @param {String} nullCase
     * @returns
     */
    transformNameAddress(address, nullCase) {
      let destination;
      if (address) {
        if (address.type !== 'Temporal') {
          destination = address.name;
        } else {
          const splitAddress = address.name.split(',');
          destination = `${splitAddress[0]}, ${splitAddress[1]}`;
        }
      } else {
        destination = nullCase;
      }
      return destination;
    },
    orderTrips(trips) {
      if (trips.length > 1) {
        trips.sort(
          (articuloA, articuloB) => new Date(articuloA.startDate).getTime() - new Date(articuloB.startDate).getTime(),
        );
      }
    },
    checkTrips: function () {
      if (this.selectedAllTrip) {
        this.checkAllTrips();
      } else {
        this.unCheckAllTrips();
      }
    },
    /**
     * checkea todos los trips que no esten asignados
     */
    checkAllTrips() {
      this.checkedTrips = [];
      for (let trip of this.tripsAssignation) {
        if (!trip.vehicle && !trip.driver) {
          this.checkedTrips.push(trip.id);
        }
      }
    },
    unCheckAllTrips() {
      this.checkedTrips = [];
    },
    async initRoute(route, index) {
      this.indexOngoing = index;
      this.onGoingIsBussy = false;
      const url = `${this.$store.getters.urlAPI}/route/${route.idRoute}/onGoing`;
      console.log('url', url);
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const body = {};
      try {
        await axios.patch(url, body, config);
        showAlert(
          this.$t('routeAssignment.alertMessages.success.title'),
          this.$t('routeAssignment.alertMessages.success.message'),
        );
        this.handlePageChange();

        this.indexOngoing = -1;
        this.onGoingIsBussy = true;
      } catch (e) {
        this.indexOngoing = -1;
        this.onGoingIsBussy = true;
        showAlert('Error', e.response.data);
      }
    },
    async getTokenUser(idUser) {
      const urlToken = `${this.$store.getters.urlAPI}/api/tokenFcm/find?idUser=${idUser}&systemNemo=LML`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        const response = await axios.get(urlToken, config);
        return response.status;
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    async getConfig() {
      try {
        const url = `${this.$store.getters.urlAPI}/configAssignation`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const result = await axios.get(url, config);
        const data = result.data.data;
        if (data && data.length > 0) {
          data.forEach((config) => {
            if (config.key === 'CARGO') {
              this.isCargoAvaiable = config.enabled;
            } else if (config.key === 'GPS_CONTROL') {
              this.isGpsControlAvailable = config.enabled;
            }
          });
        } else {
          this.isGpsControlAvailable = false;
          this.isCargoAvaiable = false;
        }
      } catch (e) {
        this.isGpsControlAvailable = false;
        this.isCargoAvaiable = false;
        console.log(e);
      }
    },
    async prepareInstantFilter() {
      this.shortCutPath = await this.$store.getters.shortCutPathOrigin;
      if (this.shortCutPath) {
        this.idRoute = [];
        this.idRoute.push(this.$route.query.idRoute || (await this.$store.getters.idRouteFlash));
        this.$store.commit('cleanIdRouteFlash');
        this.$store.commit('cleanShortCutPathOrigin');
      }
    },
    async checkTokenMassive() {
      for (let idRoute of this.checkedRoutesAssignment) {
        for (let route of this.routesFilteredData) {
          if (route.idRoute === idRoute) {
            let result = await this.getTokenUser(route.driver.id);
            if (!result) {
              return result;
            }
          }
        }
      }
      return true;
    },
    async sendMassive() {
      if (this.checkedRoutesAssignment.length === 0) {
        showAlert('Error', 'Seleccione alguna ruta para el envio masivo ...');
        return;
      }
      console.log('envio masivo masiva ...');
      let ret = await this.checkTokenMassive();
      if (ret) {
        const url = `${this.$store.getters.urlAPI}/route/massassignation`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        try {
          const response = await axios.post(url, this.checkedRoutesAssignment, config);
          if (response.status === 200) {
            showAlert(
              this.$t('routeAssignment.alertMessages.success.title'),
              this.$t('routeAssignment.alertMessages.success.message'),
            );
            this.handlePageChange();
          }
        } catch (error) {
          showAlert('Error', error);
          console.log(error);
        }
      } else {
        showAlert(
          'Error',
          'El conductor no posee la aplicación mobile activa, por ende, necesita loguearse al menos una vez para activarla y recibir rutas',
        );
      }
    },
    checkRoutes: function () {
      if (this.selectedAll) {
        this.checkAllRoutes();
      } else {
        this.unCheckAllRoutes();
      }
    },
    checkAllRoutes() {
      for (const route of this.routeFiltered) {
        if (route.driver.id !== null && route.vehicle.id !== null && route.status === 1) {
          this.checkedRoutesAssignment.push(route.idRoute);
        }
      }
    },
    unCheckAllRoutes() {
      this.checkedRoutesAssignment = [];
    },
    async prepareData() {
      this.dataAccess = this.$store.getters.dataAccess;
      await this.prepareInstantFilter();
      this.isBusy = true;
      await this.getClients(); //Llena el listado de clientes
      await this.getVehicles(); //Obtiene los vehículos. Depende del listado de clientes
      await this.getDrivers(); //Obtiene los conductores. Depende del listado de clientes
      await this.getStatus(); //Estados de la ruta
      await this.getVehicleAssignments(); //
      await this.checkDriversPermission(); //Saber si el condcutor usa app
      await this.getVehicleGps(); //Saber si el vehículo usa gps
      await this.getRoutes();
      this.getConfig();
      this.identifyVehicleOperator();
      this.splitVehicleCargo();
      this.populateDriverFilter(); //Carga lista de conductores de las rutas activas.
      this.populateVehicleFilter(); //Carga lista de vehículos de las rutas activas.
      this.populateRouteNameFilter(); //Carga lista de nombre de las rutas activas.
      this.populateRouteIdFilter(); //Carga lista de id de las rutas activas.
      this.populateLinkVehicleFilter(); //Carga lista de vehículos a vincular.
      this.populateTripExtraData();
      this.isBusy = false;
    },
    /**
     * Metodo que obtiene los tokens de aplicacion de los usuarios para identificar cuales usan
     * la aplicacion y los que no la usan.
     */
    async checkDriversPermission() {
      const urlToken = `${this.$store.getters.urlAPI}/api/user/checkPermissionByIdList?permission=mobile:nav&systemNemo=LML`;
      let body = [];
      this.filters.routeDriverList.forEach((driver) => {
        body.push(driver.id);
      });

      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        const response = await axios.post(urlToken, body, config);

        this.filters.routeDriverList.forEach((driver) => {
          driver.hasPermission = false;
          if (response.data.data.find((driverWithPermission) => driverWithPermission === driver.id) !== undefined) {
            driver.hasPermission = true;
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getVehicleGps() {
      var urlToken = `${this.$store.getters.urlAPI}/api/vehicle/checkImeiByIdList`;

      var body = [];

      this.vehicles.forEach((vehicle) => {
        body.push(vehicle.id);
      });

      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        const response = await axios.post(urlToken, body, config);

        this.vehicles.forEach((vehicle) => {
          if (vehicle.id in response.data.data) {
            vehicle.lastRegister = moment(response.data.data[vehicle.id]).format('DD/MM/YY hh:mm:ss');
            vehicle.lastRegisterRaw = moment(response.data.data[vehicle.id]).toDate().getTime();
            vehicle.hasGps = true;
          } else {
            vehicle.lastRegister = null;
            vehicle.lastRegisterRaw = null;
            vehicle.hasGps = false;
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que popula la lista de operadores para el filtro.
     */
    populateDriverFilter() {
      //Obtiene todos los operadores de las rutas que lo posean.
      console.log(this.routesAssignment);
      this.routesAssignment.forEach((route) => {
        if (route.assignations !== null) {
          route.assignations.forEach((assign) => {
            if (assign.driver !== undefined) {
              assign.driver.driverName =
                this.transformWords(assign.driver.firstName) + ' ' + this.transformWords(assign.driver.lastName);
              this.options.driverList.push(assign.driver.driverName);
            }
          });
        }
      });
      //Remueve elementos repetidos del resultado.
      this.options.driverList = this.options.driverList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que popula la lista de vehículos para el filtro.
     */
    populateVehicleFilter() {
      //Obtiene todos los vehículos de las rutas que lo posean.
      this.routesAssignment.forEach((route) => {
        if (route.assignations !== null) {
          route.assignations.forEach((assign) => {
            if (assign.vehicle !== undefined) {
              this.options.plateList.push(assign.vehicle.plate);
            }
          });
        }
      });
      //Remueve elementos repetidos del resultado.
      this.options.plateList = this.options.plateList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que popula la lista de nombre de rutas para el filtro.
     */
    populateRouteNameFilter() {
      //Obtiene todos los nombres de las rutas que lo posean.
      this.routesAssignment.forEach((route) => {
        this.options.nameList.push(route.name);
      });
      //Remueve elementos repetidos del resultado.
      this.options.nameList = this.options.nameList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que popula la lista de id de rutas para el filtro.
     */
    populateRouteIdFilter() {
      //Obtiene todos las id de las rutas que lo posean.
      this.routesAssignment.forEach((route) => {
        this.options.idList.push(route.idRoute);
      });
      //Remueve elementos repetidos del resultado.
      this.options.idList = this.options.idList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
    },
    populateTripExtraData() {
      this.routesAssignment.forEach((route) => {
        route.trips.forEach((trip) => {
          if (trip.extraData) {
            for (const value of Object.values(trip.extraData)) {
              this.options.extraData.push(value);
            }
          }
        });
      });
      this.options.extraData = [...new Set(this.options.extraData)];
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que popula la lista de vehículos a vincular para el filtro.
     */
    populateLinkVehicleFilter() {
      //Obtiene todos las patentes de todos los vehículos que lo posean.
      this.vehicles.forEach((vehicle) => {
        this.modalLinkFilters.vehicleList.push(vehicle.plate);
      });
      //Remueve elementos repetidos del resultado.
      this.modalLinkFilters.vehicleList = this.modalLinkFilters.vehicleList.filter(
        (v, i, a) => a.findIndex((t) => t === v) === i,
      );
    },
    async getDrivers() {
      const urlDrivers = `${this.$store.getters.urlAPI}/api/driver?provider=true&includeUsers=true`;

      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        let driverPromise = await axios.get(urlDrivers, config);
        this.filters.routeDriverList = driverPromise.data.data;
        this.filters.routeDriverList.forEach((driver) => {
          driver.clientName = this.filters.clientList.find((client) => driver.idClient === client.id).name;
          driver.driverNameClientName =
            (driver.username != undefined ? `${driver.username} | ` : '') +
            `${this.transformWords(driver.firstName)} ${this.transformWords(driver.lastName)} | ${driver.clientName}`;
          driver.driverName = `${this.transformWords(driver.firstName)} ${this.transformWords(driver.lastName)}`;
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getVehicles() {
      const urlVehicles = `${this.$store.getters.urlAPI}/api/vehicle?provider=true`;

      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const vehiclePromise = await axios.get(urlVehicles, config);
        this.rawVehicles = vehiclePromise.data.data;
        this.rawVehicles.forEach((vehicle) => {
          vehicle.clientName = this.filters.clientList.find((element) => element.id === vehicle.idClient).name;
          vehicle.clientPlate = vehicle.name
            ? `${vehicle.plate} | ${vehicle.name} | ${vehicle.clientName}`
            : `${vehicle.plate} | ${vehicle.clientName}`;
        });
        this.vehicles = this.rawVehicles;
      } catch (e) {
        console.log(e);
      }
    },
    async getVehicleAssignments() {
      const urlAssignments = `${this.$store.getters.urlAPI}/driverVehicle`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const vehicleAssignmentsPromise = await axios.get(urlAssignments, config);
        this.vehiclesAssignments = vehicleAssignmentsPromise.data.data;
      } catch (e) {
        console.log(e);
        console.log(e.response);
      }
    },
    async driverChecker() {
      await this.sendTrips();
      if (this.isTripValid) {
        if (this.routeDriverSelected && this.checkedVehicle) {
          if (!this.routeDriverSelected.hasPermission) {
            this.showModal('confirm-driver-with-no-permission-modal');
          } else {
            this.vinculateDataRoute();
          }
        } else {
          showAlert('error', 'Debes seleccionar un conductor y vehículo');
        }
      }
    },
    async vinculateDataRoute() {
      let errorChecked = await this.validateLinkDataForm(); //Valida que el form tenga contenido.
      //Si el conductor es de otra empresa, pregunta confirmacion.
      if (!errorChecked) {
        //Verifica si el conductor es de otra empresa.
        if (this.checkDriverVehicleIntoClient()) {
          this.assignDataTripsToRoute();
        } else {
          this.showModal('driver-different-client-modal');
        }
      }
    },
    async confirmDriverDifferentClient() {
      this.closeModal('driver-different-client-modal');
      this.assignDataTripsToRoute();
    },
    checkDriverVehicleIntoClient() {
      const tempVehicle = this.vehicles.find((vehicle) => this.checkedVehicle.id === vehicle.id);
      return this.routeDriverSelected.idClient === tempVehicle.idClient ? true : false;
    },
    validateLinkDataForm() {
      let result = false;
      console.log('probando el vehículo', this.checkedVehicle);
      if (!this.checkedVehicle) {
        showAlert('Error', this.$t('routeAssignment.modalLinkData.alertMessage.noVehicleSelected'));
        result = true;
      }
      if (!this.routeDriverSelected && !result) {
        result = true;
        showAlert('Error', this.$t('routeAssignment.modalLinkData.alertMessage.noDriverSelected'));
      }
      const tempVehicle = this.vehicles.find((vehicle) => vehicle.id === this.checkedVehicle.id);
      const now = new Date();
      //Verifica los tiempos de la ruta.
      if (now.getTime() - this.selectedRoute.endTime >= 0 && !tempVehicle.hasGps && !result) {
        result = true;
        showAlert('Error', this.$t('routeAssignment.modalLinkData.alertMessage.routePassVehicleNoGps'));
      }
      if (!this.routeDriverSelected.hasPermission && !tempVehicle.hasGps && !result) {
        result = true;
        showAlert('Error', this.$t('routeAssignment.modalLinkData.alertMessage.noGpsAndNoPermission'));
      }

      return result;
    },
    prepareLinkErrorMessage(e) {
      const vehicleIsBussy = this.transformMessage(
        e.response.data.data.isVehicleBussy,
        e.response.data.data.isVehicleBussyInPast,
        'vehicleBussy',
        'vehicleBussyInPast',
      );
      const cargoIsBussy = this.transformMessage(
        e.response.data.data.isCargoBussy,
        e.response.data.data.isCargoBussyInPast,
        'cargoBussy',
        'cargoBussyInPast',
      );
      const gpsControlIsBussy = this.transformMessage(
        e.response.data.data.isGpsControlBussy,
        e.response.data.data.isGpsControlBussyInPast,
        'gpsControlBussy',
        'gpsControlBussyInPast',
      );
      const operatorIsBussy = this.transformMessage(
        e.response.data.data.isOperatorBussy,
        e.response.data.data.isOperatorBussyInPast,
        'operatorBussy',
        'operatorBussyInPast',
      );
      const vehicleIsBussyLastmile = this.transformMessage(
        e.response.data.data.isVehicleBussyLastMile,
        e.response.data.data.isVehicleBussyInPastLastMile,
        'vehicleBussyLastmile',
        'vehicleBussyInPastLastmile',
      );
      const operatorIsBussyLastmile = this.transformMessage(
        e.response.data.data.isOperatorBussyLastMile,
        e.response.data.data.isOperatorBussyInPastLastMile,
        'operatorBussyLastmile',
        'operatorBussyInPastLastmile',
      );
      let message = '';

      if (vehicleIsBussy.length > 0) {
        message = vehicleIsBussy;
        if (operatorIsBussy.length > 0) {
          message = message + ', ' + operatorIsBussy;
        }
      } else {
        message = operatorIsBussy;
      }
      if (vehicleIsBussyLastmile.length > 0) {
        if (message !== '') {
          message += ', ' + vehicleIsBussyLastmile;
        } else {
          message += vehicleIsBussyLastmile;
        }
      }
      if (operatorIsBussyLastmile.length > 0) {
        if (message !== '') {
          message += ', ' + operatorIsBussyLastmile;
        } else {
          message += operatorIsBussyLastmile;
        }
      }
      if (cargoIsBussy.length > 0) {
        message = message.length > 0 ? message + ',' + cargoIsBussy : cargoIsBussy;
      }
      if (gpsControlIsBussy.length > 0) {
        message = message.length > 0 ? message + ',' + gpsControlIsBussy : gpsControlIsBussy;
      }

      return message;
    },
    transformMessage(isResourceBussy, isResourceBussyInPast, key, keyPast) {
      let resourceInRoute = '[';
      let resourceInPastRoute = '[';
      if (isResourceBussy) {
        isResourceBussy.forEach((idRoute) => {
          resourceInRoute = resourceInRoute + idRoute + ', ';
        });
      }
      if (isResourceBussyInPast) {
        isResourceBussyInPast.forEach((idRoute) => {
          resourceInPastRoute = resourceInPastRoute + idRoute + ', ';
        });
      }
      if (isResourceBussy) {
        resourceInRoute = resourceInRoute.substring(0, resourceInRoute.length - 2);
        resourceInRoute = resourceInRoute + ']';
      }
      if (isResourceBussyInPast) {
        resourceInPastRoute = resourceInPastRoute.substring(0, resourceInPastRoute.length - 2);
        resourceInPastRoute = resourceInPastRoute + ']';
      }
      let vehicleIsBussyPresent = '';
      if (isResourceBussy) {
        vehicleIsBussyPresent =
          isResourceBussy > 0
            ? this.$t(`routeAssignment.modalLinkData.alertMessage.${key}`, { idRouteList: resourceInRoute })
            : '';
      }
      let vehicleIsBussyInPast = '';
      if (isResourceBussyInPast) {
        vehicleIsBussyInPast =
          isResourceBussyInPast.length > 0
            ? this.$t(`routeAssignment.modalLinkData.alertMessage.${keyPast}`, {
                idRouteList: resourceInPastRoute,
              })
            : '';
      }
      return vehicleIsBussyPresent + vehicleIsBussyInPast;
    },
    async confirmUnassingDataToRouteRow(route, index) {
      showConfirmation(
        this.$t('common.modals.confirmacionTitulo'),
        this.$t('routeAssignment.table.modalConfirmationUnassigned.message', { route: route }),
        () => {
          this.unassignDataToRouteRow(route, index);
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    async unassignDataToRouteRow(route, index) {
      if (route.assignations.length > 0 && this.indexAssigned === -1 && this.unAssignedNotLoading) {
        this.unAssignedNotLoading = false;
        this.indexAssigned = index;
        this.unassignDataToRoute(route.assignations[0]);
      }
    },
    async unassignDataToRoute(route) {
      const url = `${this.$store.getters.urlAPI}/assignation/${route.id}/unassignation`;
      const headers = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        await axios.patch(url, null, headers);
        this.closeModal(linkDataFormModal);
        showAlert(
          this.$t('routeAssignment.alertMessages.success.title'),
          this.$t('routeAssignment.alertMessages.success.message'),
        );
        this.handlePageChange();
        this.indexAssigned = -1;
        this.unAssignedNotLoading = true;
      } catch (e) {
        showAlert('Error', e);
        console.log(e);
        this.indexAssigned = -1;
        this.unAssignedNotLoading = true;
      }
    },
    onChangeRouteList() {
      let routeTemp = this.routeFiltered;
      if (this.clientSelected !== null) {
        const clientCheck = this.clientSelected;
        routeTemp.filter(function (element) {
          return clientCheck.name === element.name;
        });
        this.routeFiltered = routeTemp;
      } else if (this.routesAssignment.length !== this.rawRoutes.data.length) {
        this.routeFiltered = this.rawRoutes.data;
      }
    },
    async onChangeClient() {
      this.$store.commit('setClient', this.clientSelected.id);
      console.log(this.clientSelected);
      this.prepareData();
      // await this.updatePlateFilterList();
      // this.onChangeRouteList();
    },
    updatePlateFilterList() {
      this.filters.plateList = [];
      if (this.clientSelected !== null) {
        this.rawVehiclesAssignment.forEach((element) => {
          if (this.clientSelected.id === element.idClient) {
            this.filters.plateList.push(element);
          }
        });
      } else {
        this.filters.plateList = this.rawVehiclesAssignment;
      }
    },
    identifyVehicleOperator() {
      this.vehiclesAssignments.forEach((assignation) => {
        this.vehicles.forEach((vehicle) => {
          if (assignation.idVehicle[0] === vehicle.id) {
            vehicle.vehicleDriver = '(*) ' + vehicle.clientPlate;
          }
        });
      });
      this.vehicles.forEach((vehicle) => {
        if (!vehicle.vehicleDriver) {
          vehicle.vehicleDriver = vehicle.clientPlate;
        }
      });
    },
    splitVehicleCargo() {
      console.log('Dividiendo vehículos y cargas');
      const cargoTypes = ['REMOLQUE', 'RAMPA', 'RAMPA FRIO', 'RAMPA SECA'];
      const gpsControlTypes = ['GPS CONTROL'];
      this.gpsControl = this.vehicles.filter(
        (veh) =>
          gpsControlTypes.includes(veh.vehicleType.description) && !cargoTypes.includes(veh.vehicleType.description),
      );
      this.cargos = this.vehicles.filter(
        (veh) =>
          !gpsControlTypes.includes(veh.vehicleType.description) && cargoTypes.includes(veh.vehicleType.description),
      );
      this.vehicles = this.vehicles.filter(
        (veh) =>
          !gpsControlTypes.includes(veh.vehicleType.description) && !cargoTypes.includes(veh.vehicleType.description),
      );
      console.log('vehículos final', this.vehicles);
      console.log('cargos final', this.cargos);
      console.log('gpsControl final', this.gpsControl);
    },
    async getStatus() {
      const urlStatus = `${this.$store.getters.urlAPI}/statusRoute`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        let statusPromise = await this.axios.get(urlStatus, config);
        this.statusOption = statusPromise.data.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async getRoutes() {
      //  const urlRoutes = `${this.$store.getters.urlAPI}/route?pageNum=${this.currentPageRoutes}&pageSize=${this.perPageRoutes}`;
      const urlRoutes = `${this.$store.getters.urlAPI}/route/assignationList?compressGzip=true`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const routesPromise = await this.axios.get(urlRoutes, config);
        this.totalRows = routesPromise.data.paginator ? routesPromise.data.paginator.totalRows : 0;
        this.rawRoutes = routesPromise.data;
        this.populateRoutes(routesPromise.data.data);
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    populateRoutes(routesList) {
      this.routesAssignment = [];
      this.selectedVehicles = [];
      this.rawVehiclesAssignment = [];
      console.log('Datos que se encontraton: ', routesList.length, routesList);
      routesList.forEach((element) => {
        let appPermission = false;
        let hasGps = false;
        if (element.assignations !== undefined) {
          element.assignations.forEach((assignation) => {
            if (appPermission === false) {
              const driver = assignation.driver
                ? this.filters.routeDriverList.find((driverTemp) => driverTemp.id === assignation.driver.id)
                : null;
              if (driver) {
                appPermission = driver.hasPermission;
              }
            }
            if (hasGps === false) {
              const vehicle = assignation.vehicle
                ? this.vehicleFiltered.find((vehicleTemp) => vehicleTemp.id === assignation.vehicle.id)
                : null;
              if (vehicle !== null && vehicle !== undefined) {
                hasGps = this.isGpsOnTime(vehicle);
              }
            }
          });
        }
        const startDateTemp = new Date(element.startDate);
        const startSeconds = startDateTemp.getTime();
        const startDate = new Date(startSeconds);

        const endDateTemp = new Date(element.endDate);
        const endSeconds = endDateTemp.getTime();
        const endDate = new Date(endSeconds);
        this.routesAssignment.push({
          idRoute: element.id,
          name: element.name ? element.name : '-',
          routeClient: this.filters.clientList.find((client) => client.id === element.client.id).name,
          app: appPermission,
          gps: hasGps,
          startTime: Date.parse(element.startDate),
          endTime: Date.parse(element.endDate),
          dateStartEnd:
            '[ ' +
            moment(startDate).format('DD/MM/YY HH:mm:ss') +
            ' ] - [ ' +
            moment(endDate).format('DD/MM/YY HH:mm:ss') +
            ' ]',
          status: element.status,
          trips: element.trips,
          tripsForAssignation: this.getAllTripsForAssignation(element),
          assignationsDesc: element.assignations ? this.populateAssignationRoute(element.assignations, element) : [],
          assignations: element.assignations ? element.assignations : [],
          receivedAtMainHeader: this.checkStatusAssignationOneDriver(element.assignations),
        });
      });
      this.rawVehiclesAssignment.forEach((vehicle) => {
        this.selectedVehicles.push(vehicle);
      });
    },
    /**
     * Metodo que revisa si la ruta solo pertenece a un conductor y verifica si este recibio la asignacion.
     * @param {Object} assignations, asignaciones a revisar.
     * @returns {boolean} TRUE: recibio asignacion, FALSE: no ha recibido asignacion.
     */
    checkStatusAssignationOneDriver(assignations) {
      let result = false;
      if (assignations !== undefined) {
        if (assignations.length === 1) {
          if (assignations[0].receivedAt !== undefined) {
            result = true;
          }
        }
      }
      return result;
    },
    async getClients() {
      const urlClients = `${this.$store.getters.urlAPI}/api/client/all`;
      this.filters.clientList = [];
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlClients, config);
        response.data.data.forEach((element) => {
          this.filters.clientList.push(element);
        });
        this.filters.clientList.sort(function (a, b) {
          if (a.name[0] > b.name[0]) {
            return 1;
          }
          if (a.name[0] < b.name[0]) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } catch (e) {
        console.log(e);
      }
    },
    getAllTripsForAssignation(route) {
      let result = [];
      for (let trip of route.trips) {
        if (!trip.idAssignation || this.findTripAssignation(trip.id, route.assignations)) {
          result.push(trip);
        }
      }
      return result;
    },
    findTripAssignation(id, assignations) {
      for (let assignation of assignations) {
        if (assignation !== undefined && assignation.state !== undefined && assignation.state !== null) {
          if (assignation.state === 'NOTASSIGNED') {
            if (assignation.trips === undefined || assignation.trips === null) {
              return false;
            }
            for (let trip of assignation.trips) {
              if (trip.id === id) {
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    async initLinkData(route) {
      await this.changeTripInfo(route);
      this.showModal(linkDataFormModal);
    },
    async changeTripInfo(route) {
      this.isTripDetailBusy = true;
      console.log('probando la ruta de asignacion', route);
      this.resetDataTrips();
      await this.setDefaultVehicleDriver();
      this.isDataLinkBusy = false;
      this.selectedAllTrip = false;
      this.loadSelected = null;
      this.checkedVehicle = null;
      this.checkedCargo = null;
      this.checkedGpsControl = null;
      this.currentPageVehicles = 1;
      this.selectedRoute = await route;
      this.tripsAssignation = this.addVehicleOperator(this.selectedRoute);
      this.processTripsAssignation(this.tripsAssignation);
      console.log('Test lista ', this.tripsAssignation);
      await this.checkCurrentVehicleRoute();
      this.setFirstLinkedVehicle();
      this.isTripDetailBusy = false;
    },
    getExtraDataFromTrip(extraData) {
      if (extraData) {
        return Object.values(extraData).join(', ');
      } else {
        return '';
      }
    },
    addVehicleOperator(route) {
      if (route.assignations) {
        route.assignations.forEach((assignation) => {
          assignation.trips.forEach((tripAssign) => {
            route.trips.forEach((trip) => {
              if (trip.id === tripAssign.id) {
                trip.driver = assignation.driver.firstName + ' ' + assignation.driver.lastName;
                trip.vehicle = assignation.vehicle.plate;
                trip.cargo = assignation.cargo ? assignation.cargo.plate : null;
                trip.gpsControl = assignation.gpsControl ? assignation.gpsControl.plate : null;
                return;
              }
            });
          });
        });
      }
      console.log('testing', route.trips);
      return route.trips;
    },
    setFirstLinkedVehicle() {
      if (this.checkedVehicle) {
        const element = this.checkedVehicle.id;
        this.vehicleFiltered.sort(function (x, y) {
          return x.id === element ? -1 : y.id === element ? 1 : 0;
        });
      }
    },
    checkCurrentVehicleRoute() {
      this.checkedVehicle = null;
      this.vehicles.forEach((vehicle) => {
        this.selectedVehicles.forEach((vehicleSelected) => {
          if (this.selectedRoute.idRoute === vehicleSelected.idRoute && vehicle.id === vehicleSelected.id) {
            this.checkedVehicle = vehicle;
          }
        });
      });
    },
    setDefaultVehicleDriver() {
      this.routeClientSelected = null;
      this.routeGroupSelected = null;
      this.routeTypeSelected = null;
      this.routeDriverSelected = null;
      this.checkedVehicle = null;
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    async handlePageChange() {
      this.isBusy = true;
      await this.getRoutes();
      this.isBusy = false;
    },
    setFirstVehiclePage() {
      this.currentPageVehicles = 1;
    },
    dateToSeconds(element) {
      const date = new Date(element);
      return date.getTime();
    },
    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.isFilterShown && !this.isFilterClicked) {
        this.isFilterShown = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    activeFilterModal() {
      this.isFilterShownModal = !this.isFilterShownModal;
      this.isFilterClickedModal = !this.isFilterClickedModal;
    },
    activeUseFilterModal() {
      this.isFilterClickedModal = true;
    },
    toogleFilterModal() {
      if (this.isFilterShownModal && !this.isFilterClickedModal) {
        this.isFilterShownModal = false;
      }
      if (this.isFilterClickedModal) {
        this.isFilterClickedModal = false;
      }
    },
    limitText(count) {
      return this.$t('routeAssignment.search.limitText') + (count + 1);
    },
    /**
     * Metodo que verifica la ultima actividad gps del vehículo.
     * @param {Object} vehicle, datos del vehículo a revisar.
     * @returns {boolean} el resultado de la verificacion.
     */
    isGpsOnTime(vehicle) {
      const gpsRegisterDate = moment(new Date(vehicle.lastRegisterRaw));
      const nowDate = moment(new Date());

      const duration = moment.duration(nowDate.diff(gpsRegisterDate));
      const hours = duration.asHours();

      //El vehículo esta recientemente activo.
      if (hours < 48) {
        return true;
      }

      return false;
    },
    /**
     * Metodo que retorna a la vista anterior.
     * @param {String} shortCutPath, nombre de la ruta.
     * @returns vista anterior.
     */
    returnToPage(shortCutPath) {
      return this.$router.push({ name: shortCutPath });
    },
    /**@author Nicolas Sepulveda
     * Metodo para transformar las palabras a capitalize,
     * Ejemplo: jOSue = Josue
     * @param {String} words
     * @returns
     */
    transformWords(words) {
      let listWords = words.split(' ');
      let finalWord = '';
      listWords.forEach((word) => {
        if (word) {
          if (finalWord === '') {
            finalWord = this.capitalize(word);
          } else {
            finalWord = finalWord + ' ' + this.capitalize(word);
          }
        }
      });
      return finalWord;
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    /**
     * Metodo que limpia el filtrado.
     */
    cleanFilter() {
      this.filters.from = null;
      this.filters.to = null;
      this.keywordOper = null;
      this.keywordPlateTable = null;
      this.name = null;
      this.idRoute = null;
      this.statusSelected = null;
      this.extraData = null;
    },
  },
  computed: {
    rows() {
      return this.routesAssignment.length;
    },
    fromManagement() {
      return !!this.$route.query.fromManagement;
    },
    /** @author Nicolás Sepúlveda Valdivia
     * metodo que rellena el filtro de driver si es que el vehículo seleccionado ya posee a un driver
     * @returns la lista de conductores
     */
    driverSelected() {
      //verifica si no hay valores nulos
      if (this.vehiclesAssignments) {
        this.vehiclesAssignments.forEach((assignment) => {
          //se identifica la asignación correspondiente al vehículo que se selecciono
          if (assignment.idVehicle[0] === this.checkedVehicle.id) {
            this.filters.routeDriverList.forEach((driver) => {
              //si la asignación encuentra el id del driver rellena el filtro con el valor correspondiente
              if (driver.id === assignment.idDriver) {
                this.routeDriverSelected = driver;
              }
            });
          }
        });
      }
      return this.filters.routeDriverList;
    },
    vehicleFiltered() {
      let vehicleFiltered = this.vehicles;
      this.isFilterAppliedModal = false;
      this.setFirstVehiclePage();

      if (this.routeClientSelected) {
        vehicleFiltered = vehicleFiltered.filter((i) => i.idClient === this.routeClientSelected.id);
        if (!this.isFilterAppliedModal) {
          this.isFilterAppliedModal = true;
        }
      }
      if (this.routeGroupSelected) {
        vehicleFiltered = vehicleFiltered.filter((i) => i.group.id === this.routeGroupSelected.id);
        if (!this.isFilterAppliedModal) {
          this.isFilterAppliedModal = true;
        }
      }
      if (this.routeTypeSelected) {
        vehicleFiltered = vehicleFiltered.filter((i) => i.vehicleType.id === this.routeTypeSelected.id);
        if (!this.isFilterAppliedModal) {
          this.isFilterAppliedModal = true;
        }
      }
      if (this.keywordPlate) {
        vehicleFiltered = vehicleFiltered.filter((i) => i.plate === this.keywordPlate);
        if (!this.isFilterAppliedModal) {
          this.isFilterAppliedModal = true;
        }
      }
      if (this.keywordVehicle) {
        vehicleFiltered = vehicleFiltered.filter((item) =>
          item.plate.toUpperCase().includes(this.keywordVehicle.toUpperCase()),
        );
        if (!this.isFilterAppliedModal) {
          this.isFilterAppliedModal = true;
        }
      }
      return vehicleFiltered;
    },
    vehicleRows() {
      return this.vehicles.length;
    },
    routeFiltered() {
      this.routesFilteredData = this.routesAssignment;
      this.isFilterApplied = false;

      if (this.name && this.name.length > 0) {
        this.routesFilteredData = this.routesFilteredData.filter((route) => {
          if (route.name !== undefined) {
            return this.name.some((nameRoute) => {
              if (nameRoute !== undefined) {
                return nameRoute === route.name;
              }
            });
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }

      if (this.idRoute && this.idRoute.length > 0) {
        this.routesFilteredData = this.routesFilteredData.filter((route) => {
          if (route.idRoute !== undefined) {
            return this.idRoute.some((idRoute) => {
              if (idRoute !== undefined) {
                return idRoute === route.idRoute;
              }
            });
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }

      if (this.statusSelected && this.statusSelected.length > 0) {
        this.routesFilteredData = this.routesFilteredData.filter((route) => {
          if (route.status !== undefined) {
            return this.statusSelected.some((status) => {
              if (status.id !== undefined) {
                return status.id === route.status;
              }
            });
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }

      if (this.keywordPlateTable && this.keywordPlateTable.length > 0) {
        this.routesFilteredData = this.routesFilteredData.filter((route) => {
          if (route.assignations !== null || route.assignations !== undefined) {
            return route.assignations.some((assign) => {
              if (assign.vehicle !== undefined) {
                return this.keywordPlateTable.some((plate) => {
                  if (plate !== undefined) {
                    return plate === assign.vehicle.plate;
                  }
                });
              }
            });
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }

      if (this.keywordOper && this.keywordOper.length > 0) {
        this.routesFilteredData = this.routesFilteredData.filter((route) => {
          if (route.assignations !== null || route.assignations !== undefined) {
            return route.assignations.some((assign) => {
              if (assign.driver !== undefined) {
                return this.keywordOper.some((driverName) => {
                  if (driverName !== undefined) {
                    return driverName === assign.driver.driverName;
                  }
                });
              }
            });
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.extraData && this.extraData.length > 0) {
        this.routesFilteredData = this.routesFilteredData.filter((route) => {
          if (route.trips !== null || route.trips !== undefined) {
            return route.trips.some((trip) => {
              if (trip.extraData !== undefined && Object.values(trip.extraData).includes(this.extraData)) {
                return trip;
              }
            });
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }

      if (this.filters.from) {
        const startDate = this.dateToSeconds(this.filters.from);
        this.routesFilteredData = this.routesFilteredData.filter((item) => item.startTime >= startDate);
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }

      if (this.filters.to) {
        const endDate = this.dateToSeconds(this.filters.to);

        this.routesFilteredData = this.routesFilteredData.filter((item) => item.endTime <= endDate);
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      return this.routesFilteredData;
    },
    routeAssignmentFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'select',
          label: '',
          ...common,
        },
        {
          key: 'appGpsIcon',
          label: '',
          ...common,
        },
        {
          key: 'idRoute',
          label: this.$t('routeAssignment.table.idRoute'),
          ...common,
        },
        {
          key: 'name',
          label: this.$t('routeAssignment.table.nameRoute'),
          ...common,
        },
        // {
        //   key: 'routeClient',
        //   label: this.$t('routeAssignment.table.client'),
        //   ...common,
        // },
        {
          key: 'vehicle.plate',
          label: this.$t('routeAssignment.table.vehicleCargo'),
          ...common,
        },
        {
          key: 'driver.driverName',
          label: this.$t('routeAssignment.table.driver'),
          ...common,
        },
        {
          key: 'status',
          label: this.$t('routeAssignment.table.status'),
          ...common,
        },
        {
          key: 'dateStartEnd',
          label: this.$t('routeAssignment.table.dateStartEnd'),
          ...common,
        },
        {
          key: 'shortcut',
          label: this.$t('routeAssignment.table.shortcut'),
          ...common,
        },
        {
          key: 'actions',
          label: this.$t('routeAssignment.table.actions'),
          ...common,
        },
        {
          key: 'expander',
          tdClass: 'text-left',
          label: '',
          ...common,
        },
      ];
    },
    tripsFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      let field = [
        {
          key: 'select',
          label: '',
          ...common,
        },
        {
          key: 'id',
          label: this.$t('routeAssignment.table.idTrip'),
          ...common,
        },
        {
          key: 'originDesc',
          label: this.$t('routeAssignment.table.origin'),
          ...common,
        },
        {
          key: 'destinationDesc',
          label: this.$t('routeAssignment.table.destination'),
          ...common,
        },
        {
          key: 'driver',
          label: this.$t('routeAssignment.table.driver'),
          ...common,
        },
        {
          key: 'vehicle',
          label: this.$t('routeAssignment.table.vehicle'),
          ...common,
        },
      ];
      if (this.isCargoAvaiable) {
        field = [
          ...field,
          {
            key: 'cargo',
            label: this.$t('routeAssignment.table.cargo'),
            ...common,
          },
        ];
      }
      if (this.isGpsControlAvailable) {
        field = [
          ...field,
          {
            key: 'gpsControl',
            label: this.$t('routeAssignment.table.gpsControl'),
            ...common,
          },
        ];
      }
      field = [
        ...field,
        {
          key: 'extraData',
          label: this.$t('routeAssignment.table.extraField'),
          ...common,
        },
      ];
      return field;
    },
    driverFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'select',
          label: '',
          ...common,
        },
        {
          key: 'driverNameClientName',
          label: this.$t('routeAssignment.table.nameRoute'),
          ...common,
        },
        {
          key: 'clientName',
          label: this.$t('routeAssignment.modalLinkData.table.client'),
          ...common,
        },
        {
          key: 'gpsIcon',
          label: '',
          ...common,
        },
      ];
    },
    vehicleFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'select',
          label: '',
          ...common,
        },
        {
          key: 'vehicleDriver',
          label: this.$t('routeAssignment.modalLinkData.table.plate'),
          ...common,
        },
        {
          key: 'clientName',
          label: this.$t('routeAssignment.modalLinkData.table.client'),
          ...common,
        },
        {
          key: 'group.name',
          label: this.$t('routeAssignment.modalLinkData.table.group'),
          ...common,
        },
        {
          key: 'vehicleType.description',
          label: this.$t('routeAssignment.modalLinkData.table.type'),
          ...common,
        },
        {
          key: 'vehicleType.description',
          label: this.$t('routeAssignment.modalLinkData.table.type'),
          ...common,
        },
        {
          key: 'vehicleType.lastRegister',
          label: this.$t('routeAssignment.modalLinkData.table.lastRegister'),
          ...common,
        },
        {
          key: 'gpsIcon',
          label: '',
          ...common,
        },
      ];
    },
    tripRows() {
      return this.tripsAssignation.length;
    },
  },
};
